export const determineStyleBasedOnLineWidth = (isCursive, isNarrow, obj, isWide = false) => {
  if (isWide) {
    return obj.wide;
  }
  if (isCursive && isNarrow) {
    return obj.cursiveAndNarrow;
  }
  if (isNarrow) {
    return obj.narrow;
  }
  if (isCursive) {
    return obj.cursive;
  }
  return obj.regular;
};

export const getFontSize = (isCursive, isNarrow, isWide = false) => {
  if (isWide) {
    return 62;
  }
  if (isCursive && isNarrow) {
    return 39;
  }
  if (isNarrow) {
    return 28;
  }
  if (isCursive) {
    return 54;
  }
  return 42;
};
